<template>
    <div class="na-form">
        <div v-if="nodeList" class="mnvGridBox">
            <div class="mnvTile mnvBack" v-if="key != ''" @click="selectParent()">
                <div class="mnvTileIcon fal fa-long-arrow-left">
                </div>
                <div class="mnvGridGroupName">Back</div>
            </div>
            <div v-for="node in nodeList" class="mnvContents;" v-bind:key="node.Key">
                <div @click="selectNode(node)" v-bind:class="'mnvTile '+ node.Id">
                    <div v-bind:class="node.IconClass">
                    </div>
                    <div class="mnvGridGroupName">{{ node.Title }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import $ from 'jquery'
    export default {
        name: 'IndexSite',
        components: {
        },
        computed: {
            siteMapList() {
                return this.$store.state.siteMapStore.siteMap
            },
            nodeList() {
                return this.siteMapList.filter(m => m.ParentKey == this.$store.state.siteMapStore.currentKey)
            },
            siteMapRoot() {
                return this.$store.state.siteMapStore.siteMapRoot
            },
            IsRoot() {
                return this.$store.state.siteMapStore.siteMapRoot && (this.$store.state.siteMapStore.currentKey == this.$store.state.siteMapStore.siteMapRoot.Key);
            },
            key() {
                return this.$store.state.siteMapStore.currentKey
            },
            path() {
                return this.$store.state.siteMapStore.currentKey
            }
        },
        data() {
            return {
                parentKey: "",
                parent: null,
                bitv: window.UserInfo.CurrentUserBitv
            };
        },
        props: {
            menuId: {
                type: [String],
                required: true,
                default: ""
            },
        },
        watch: {
            path: function (newVal) {
                var node
                if (newVal == '') {
                    node = this.$store.state.siteMapStore.siteMapRoot
                }
                else {
                    node = this.$store.state.siteMapStore.siteMap.find(m => m.Key == newVal)
                }
                var path = ""
                do {
                    path = `<div class='bcMenuElement'><a href='${node.Url}'>${node.Title}</a></div>` + path
                    node = node.Parent
                    if (node == null) {
                        break
                    }
                    path = "<div class='bcSeparator'>/</div>" + path
                } while (node != null)
                $(".bcBreadCrumb").html(path)
            },
        },
        created: function () {
            window.addEventListener("bitvChange", function () { this.bitv = window.UserInfo.CurrentUserBitv }.bind(this), false)
        },
        mounted: function () {
            this.$store.dispatch("getSiteMap", this.menuId)
            this.$store.dispatch("createAvatarIfMissing")
        },
        methods: {
            selectNode: function (node) {
                if (node.HasChildren) {
                    this.$store.state.siteMapStore.currentKey = node.Key
                    this.parentKey = node.ParentKey
                }
                else {
                    window.LoadPanel.Show()
                    window.location.href = node.Url
                }
            }, selectParent: function () {
                this.$store.state.siteMapStore.currentKey = this.parentKey
            }
        }
    }
</script>
<style>
    .mnvGridBox {
        padding: 0;
        list-style: none;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-flow: wrap;
        -webkit-flex-flow: row wrap;
        justify-content: flex-start;
        max-width: 1050px;
        gap: 20px;
    }

    .mnvTile:hover {
        opacity: .7;
    }

    a:hover {
        color: var(--back-hover-color);
    }

    .mnvTile {
        background: var(--tile-bg-color);
        box-sizing: border-box;
        color: var(--tile-color);
        padding: 5px 13px;
        width: 182px;
        height: 182px;
        cursor: pointer;
        display: flex;
        align-items: baseline;
        gap: 4px;
    }

    .mnvBack {
    }

    .mnvContents {
        font-size: 17px;
    }

    .mnvGridGroupName {
        margin: 7px;
    }

    .mnvGridIcon {
        left: 106px;
        top: 73px;
        position: relative;
    }

        .mnvGridIcon img {
            height: 70px;
        }

    .mnvTileIcon:before {
        font-size: 40px;
        position: relative;
        left: 122px;
        display: block;
        top: 125px;
        width: 0;
        height: 0;
    }

    .mnvTile.MnHelp:hover {
        background-color: var(--back-hover-color);
    }

    .mnvTile.MnHelp {
        background-color: var(--m01-color-1);
        opacity: 1;
    }

    @media only screen and (max-width: 450px) {
        .mnvGridBox {
            justify-content: center;
        }
    }
</style>
